import { isMultiLineControl, rankWith } from "@jsonforms/core";

export default rankWith(4, isMultiLineControl);
